/**
 * API de contexto de género WOMAN/MAN para el Home dual.
 *
 * Fuente de verdad runtime: html[data-custom-gender="woman|man"]
 * (estampado pre-paint por snippets/custom_gender-context.liquid).
 *
 * Contrato para componentes consumidores:
 * - Renderizar {% render 'custom_gender-context' %} antes de su markup.
 * - Mostrar/ocultar por CSS puro: html[data-custom-gender="man"] .custom_x--woman { display: none }
 * - Cambiar de género: window.customGender.set('man', 'mi-fuente') o un elemento
 *   con data-custom-gender-set="man" (delegado global, aria-pressed automático).
 * - Reaccionar por JS: document.addEventListener('custom:gender:change', ...) con
 *   detail { gender, previous, source }. Nunca re-despachar desde un listener:
 *   set() ya es no-op cuando el valor no cambia.
 */
const STORAGE_KEY = 'velez_custom_gender';
const GENDERS = ['woman', 'man'];
const root = document.documentElement;

function getGender() {
  const gender = root.dataset.customGender;
  return GENDERS.includes(gender) ? gender : 'woman';
}

function setGender(gender, source = 'api') {
  if (!GENDERS.includes(gender)) return;
  const previous = getGender();
  if (gender === previous) return;
  root.dataset.customGender = gender;
  try {
    localStorage.setItem(STORAGE_KEY, gender);
  } catch (e) {}
  syncPressedStates();
  document.dispatchEvent(
    new CustomEvent('custom:gender:change', { detail: { gender, previous, source } })
  );
}

function syncPressedStates() {
  const current = getGender();
  document.querySelectorAll('[data-custom-gender-set]').forEach((el) => {
    el.setAttribute('aria-pressed', el.dataset.customGenderSet === current ? 'true' : 'false');
  });
}

document.addEventListener('click', (event) => {
  const trigger = event.target.closest('[data-custom-gender-set]');
  if (!trigger) return;
  setGender(trigger.dataset.customGenderSet, 'toggle');
});

document.addEventListener('shopify:section:load', syncPressedStates);

syncPressedStates();

window.customGender = { get: getGender, set: setGender, GENDERS };

export { getGender, setGender, GENDERS };
